// Production mode environment
export const environment = {
  useProdMode: true,
  appConfigUri: '/assets/app.config.json'
};
